/* tslint:disable */
/* eslint-disable */
/**
 * NLBS SDPS Secure Zone API
 * NLBS SDPS Secure Zone API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Agency describes a Transferring Agency.
 * @export
 * @interface Agency
 */
export interface Agency {
    /**
     * 
     * @type {boolean}
     * @memberof Agency
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof Agency
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof Agency
     */
    lastModified: Date;
    /**
     * 
     * @type {string}
     * @memberof Agency
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Agency
     */
    proxyId?: string;
    /**
     * 
     * @type {string}
     * @memberof Agency
     */
    proxyName?: string;
    /**
     * 
     * @type {string}
     * @memberof Agency
     */
    sftpUsername: string;
    /**
     * UUID
     * @type {string}
     * @memberof Agency
     */
    uuid: string;
}

/**
 * Check if a given object implements the Agency interface.
 */
export function instanceOfAgency(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lastModified" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "sftpUsername" in value;
    isInstance = isInstance && "uuid" in value;

    return isInstance;
}

export function AgencyFromJSON(json: any): Agency {
    return AgencyFromJSONTyped(json, false);
}

export function AgencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Agency {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': json['active'],
        'id': json['id'],
        'lastModified': (new Date(json['last_modified'])),
        'name': json['name'],
        'proxyId': !exists(json, 'proxy_id') ? undefined : json['proxy_id'],
        'proxyName': !exists(json, 'proxy_name') ? undefined : json['proxy_name'],
        'sftpUsername': json['sftp_username'],
        'uuid': json['uuid'],
    };
}

export function AgencyToJSON(value?: Agency | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'id': value.id,
        'last_modified': (value.lastModified.toISOString()),
        'name': value.name,
        'proxy_id': value.proxyId,
        'proxy_name': value.proxyName,
        'sftp_username': value.sftpUsername,
        'uuid': value.uuid,
    };
}

